import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import WeddingInvite from './pages/WeddingInvite';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<WeddingInvite />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
